import React, { lazy, Suspense } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { useCustomLogger } from '@vp/pdp-ubik-logging';

import { isPaypalMessageLocale } from '../../domain/paypal';

const LazyPaypalMessageWrapper = lazy(() =>
  import('./PaypalMessageWrapper').then((m) => ({ default: m.PaypalMessageWrapper }))
);

interface PaypalMessageSectionProps {
  locale: string;
  cartTenantId: string;
  mpvId: string;
  productKey: string;
}

export const PaypalMessageSection: React.FC<PaypalMessageSectionProps> = (props) => {
  const { logger } = useCustomLogger();

  if (!isPaypalMessageLocale(props.locale)) return null;

  return (
    <ErrorBoundary
      fallback={null}
      onError={(error) => logger.error('PayPal message render failed', { error: error.message })}
    >
      <Suspense fallback={null}>
        <LazyPaypalMessageWrapper
          locale={props.locale}
          cartTenantId={props.cartTenantId}
          mpvId={props.mpvId}
          productKey={props.productKey}
        />
      </Suspense>
    </ErrorBoundary>
  );
};
